import React from "react";
import Error from "./common/Error";

const InternalError = props => {

    return (
        <Error errorStatus={'500'} errorText={'An unexpected error happened!'} errorDescription={'Please contact the application support!'} />
    );

};

export default InternalError;